import { isLoggedIn } from 'utils/auth';

export default (store) => ({
  path: "campaign-forms/staticFileExchange",
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure(
      [],
      (require) => {
        const component = require("./StaticFileExchange").default;
        callback(null, component);
      },
      "CreateCohorts"
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/StaticFileExchange/index.js